import React, { useState, useEffect } from 'react';

const SpaceOnboardingTooltip: React.FC = () => {
  const [isFirstTime, setIsFirstTime] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Vérifier si c'est la première fois que l'utilisateur voit un Space
    const hasSeenSpaces = localStorage.getItem('hasSeenSpaces');
    if (!hasSeenSpaces) {
      setIsFirstTime(true);
      setShowTooltip(true);
      // Marquer comme vu après 5 secondes
      setTimeout(() => {
        localStorage.setItem('hasSeenSpaces', 'true');
        setShowTooltip(false);
      }, 8000);
    }
  }, []);

  if (!isFirstTime || !showTooltip) return null;

  return (
    <div className="absolute -top-2 -right-2 z-20">
      {/* Bulle de notification */}
      <div className="relative">
        <div className="bg-cyan-500 text-black text-xs font-medium px-3 py-2 rounded-lg shadow-lg border border-cyan-400 animate-pulse">
          <div className="flex items-center space-x-2">
            <span>🎙️</span>
            <span>Nouveau ! Discussions vocales</span>
          </div>
          <div className="text-[10px] mt-1 opacity-80">
            Cliquez pour rejoindre en tant qu'auditeur
          </div>
        </div>
        
        {/* Petite flèche */}
        <div className="absolute top-full left-1/2 transform -translate-x-1/2">
          <div className="w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-cyan-500"></div>
        </div>
      </div>
      
      {/* Bouton pour fermer */}
      <button 
        onClick={() => setShowTooltip(false)}
        className="absolute -top-1 -right-1 w-4 h-4 bg-gray-700 text-white text-xs rounded-full flex items-center justify-center hover:bg-gray-600"
      >
        ×
      </button>
    </div>
  );
};

export default SpaceOnboardingTooltip;
